module.exports = __webpack_public_path__ + "static/media/nft-SquidGameToy.67851fde.png";